module.exports = __webpack_public_path__ + "img/new-object-megaphone.963ab6df.png";